import {
  faTimes,
  faAsterisk,
  faEnvelope } from
"@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState, useEffect, useRef } from "react";
import CounselorMsgService from "../../../services/Counselor/CounselorMsgService";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import MsgDataService from "../../../services/MsgService";
import MessageSendSpinner from "../../shared/MessageSendSpinner";
import "./StudentMessage.css";

const CreateMessage = ({
  role,
  close,
  setOpenedCannedModal,
  message,
  setMessage,
  getMessageDetails,
  selectedMessageFromScheduled
}) => {
  const inputTypeRef = useRef();
  const timeoutRef = useRef();
  const [studentName, setStudentName] = useState();
  const [showStudentContainer, setShowStudentContainer] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [groupSections, setGroupSections] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState([]);
  const [selectedStudentName, setSelectedStudentName] = useState([]);
  const [ackOrFeedback, setAckOrFeedback] = useState();
  const [, setShowFeedBackOrAckOption] = useState(false);
  const [ackParentValue, setAckParentValue] = useState(false);
  const [subjectValue, setSubjectValue] = useState("");
  const [selectedFile, setSelectedFile] = useState();
  const [sending, setSending] = useState(false);
  const [user] = useState(
    localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : []
  );
  const [, setPriorityValue] = useState("normal");
  const [feedbackOrAckText, setFeedbackOrAckText] = useState();
  const [, setShowFeedbackOrAckTextContainer] =
  useState(false);
  const inputFileRef = useRef();
  const [fileDataFromApi, setFileDataFromApi] = useState();

  const closeCreateMessage = () => {
    setMessage("");
    setStudentName("");
    setSubjectValue("");
    setSelectedFile();
    setFeedbackOrAckText();
    setAckOrFeedback();
    setSelectedStudent([]);
    setSelectedStudentName([]);
    setStudentList([]);
    setGroupSections([]);
    setFileDataFromApi();
    setPriorityValue("normal");
    if (inputTypeRef.current) inputTypeRef.current.value = null;
    if (inputFileRef.current) inputFileRef.current.value = null;
    close();
  };

  const getStudent = (value) => {
    let obj = {
      role: "student",
      q: value,
      school_id: user?.school_id,
      student: "all",
      page: 1
    };
    GetStudentService.getStudentListForMessage(obj)
    .then((data) => {
      const rawList = data?.data?.result || data?.data?.objects || [];
      const list = rawList.map((item) => ({
        ...item,
        id: item?.id,
        name:
        item?.name ||
        `${item?.first_name || ""} ${item?.last_name || ""}`.trim(),
        current_grade: item?.current_grade
      }));
      setShowStudentContainer(true);
      setStudentList(list);
    })
    .catch(() => {
      setStudentList([]);
    });
  };

  const normalizeGroupResponse = (groupsPayload) => {
    if (!groupsPayload) {
      return { sections: [], flat: [] };
    }
    // Categorized object: { Grade: [...], Progress: [], ... }
    if (typeof groupsPayload === "object" && !Array.isArray(groupsPayload)) {
      const sections = Object.keys(groupsPayload)
      .map((key) => ({
        title: String(key).replace(/_/g, " "),
        items: Array.isArray(groupsPayload[key]) ? groupsPayload[key] : []
      }))
      .filter((section) => (section.items || []).length > 0);
      return {
        sections,
        flat: sections.flatMap((section) => section.items)
      };
    }
    // Legacy array format
    if (Array.isArray(groupsPayload)) {
      return {
        sections:
        groupsPayload.length > 0 ?
        [{ title: "Groups", items: groupsPayload }] :
        [],
        flat: groupsPayload
      };
    }
    return { sections: [], flat: [] };
  };

  const getGroup = (value) => {
    let obj = {
      counselor_id: user?.counselor_id,
      q: value,
      school_id: user?.school_id
    };
    GetStudentService.getGroupForCreateMessage(obj)
    .then((data) => {
      const groupsPayload = data?.data?.groups ?? data?.data;
      const { sections, flat } = normalizeGroupResponse(groupsPayload);
      setGroupSections(sections);
      setStudentList(flat);
      setShowStudentContainer(true);
    })
    .catch(() => {
      setGroupSections([]);
      setStudentList([]);
    });
  };

  const handleNameChange = () => {
    clearTimeout(timeoutRef.current);
    const nextValue = inputTypeRef.current?.value || "";
    if (!nextValue) {
      setShowStudentContainer(false);
      setStudentList([]);
      setGroupSections([]);
    }
    setStudentName(nextValue);
    timeoutRef.current = setTimeout(() => {
      if (role === "student") {
        getStudent(inputTypeRef.current.value);
      } else if (role === "group") {
        getGroup(inputTypeRef.current.value);
      }
    }, 1000);
    setShowStudentContainer(true);
  };

  const handleFileChange = async () => {
    await setSelectedFile(inputFileRef.current.files[0]);
  };

  const submitAttachment = async () => {
    if (selectedFile) {
      MsgDataService.attachment(selectedFile)
      .then((data) => {
        setFileDataFromApi(data.data.Status);
        inputFileRef.current.value = "";
      })
      .catch(() => {});
    }
  };

  useEffect(() => {
    submitAttachment();
  }, [selectedFile]);

  const selectedStudentHandler = (value) => {
    const alreadySelected = (selectedStudent || []).some(
      (item) => item?.id === value?.id
    );
    if (alreadySelected) {
      setShowStudentContainer(false);
      setStudentList([]);
      setGroupSections([]);
      setStudentName("");
      if (inputTypeRef.current) inputTypeRef.current.value = "";
      return;
    }
    setSelectedStudent([...(selectedStudent || []), value]);
    setStudentName("");
    setSelectedStudentName([...(selectedStudentName || []), value?.name]);
    setShowStudentContainer(false);
    setStudentList([]);
    setGroupSections([]);
    if (inputTypeRef.current) inputTypeRef.current.value = "";
  };

  const removeSelectedName = (index) => {
    selectedStudent.splice(index, 1);
    setSelectedStudent([...selectedStudent]);
    selectedStudentName.splice(index, 1);
    setSelectedStudentName([...selectedStudentName]);
  };

  const canSend =
  role === "student" ?
  selectedStudent && selectedStudent.length > 0 && message :
  selectedStudent &&
  selectedStudent.length > 0 &&
  message &&
  subjectValue;

  const sendGroupMessage = () => {
    if (sending) return;
    let answer = {
      ack: parseInt(ackOrFeedback),
      ackError: false,
      ackText: ackOrFeedback === "0" ? "feedback" : "ack",
      text: feedbackOrAckText,
      textError: false
    };
    let selectedStudentId = selectedStudent.map((item) => item.id);
    let groupObj = {
      answers: ackOrFeedback && feedbackOrAckText ? answer : [],
      body: message,
      groups: selectedStudentId,
      priority: { value: "normal", text: "Normal" },
      school_id: user?.school_id,
      need_ack_parents: ackParentValue,
      subject: subjectValue,
      counselor_id: user?.counselor_id
    };
    if (fileDataFromApi) {
      groupObj["attachment_url"] = fileDataFromApi?.image_name;
    }
    setSending(true);
    CounselorMsgService.sendGroupMessage(groupObj)
    .then(() => {
      setMessage("");
      setStudentName();
      setSelectedStudent();
      setShowFeedBackOrAckOption(false);
      setShowFeedbackOrAckTextContainer(false);
      setFeedbackOrAckText();
      setPriorityValue("normal");
      setSubjectValue("");
      setAckParentValue(false);
      setAckOrFeedback();
      if (inputTypeRef.current) inputTypeRef.current.value = null;
      getMessageDetails();
      closeCreateMessage();
    })
    .catch(() => {})
    .finally(() => setSending(false));
  };

  const sendMessage = () => {
    if (sending) return;
    let obj = {
      parent_ack: ackParentValue,
      event_type: "school_it_student",
      dst_id: [selectedStudent && selectedStudent[0]?.id]
    };
    if (fileDataFromApi) {
      obj["attachment_url"] = fileDataFromApi?.image_name;
    }
    if (!selectedMessageFromScheduled) {
      obj["message_body"] = message;
    } else if (selectedMessageFromScheduled) {
      obj["message_body"] = message;
    }
    setSending(true);
    GetStudentService.sendMessage(obj)
    .then(() => {
      setMessage();
      setStudentName();
      setSelectedStudent();
      setShowFeedBackOrAckOption(false);
      setShowFeedbackOrAckTextContainer(false);
      setFeedbackOrAckText();
      setSubjectValue();
      setAckParentValue(false);
      setAckOrFeedback();
      if (inputTypeRef.current) inputTypeRef.current.value = null;
      getMessageDetails();
      closeCreateMessage();
    })
    .catch(() => {})
    .finally(() => setSending(false));
  };

  return (
    <Fragment>
      <div className="new-student-message-container">
        <div className="school-it-create-header">
          <h2>
            {role === "student" ?
            "New Student Message" :
            role === "group" ?
            "New Group Message" :
            ""}
          </h2>
          <FontAwesomeIcon
            icon={faTimes}
            className="school-it-create-close"
            onClick={closeCreateMessage} />
          
        </div>

        <button
          type="button"
          className="school-it-create-schedule"
          onClick={() => setOpenedCannedModal(true)}>
          
          Select from Scheduled
        </button>

        <div className="school-it-create-field">
          <label className="school-it-create-label">To</label>
          <div className="school-it-create-input-wrap">
            <input
              ref={inputTypeRef}
              type="text"
              placeholder={`Type a ${
              role === "student" ? "student" : "group"
              } name to add`}
              onChange={handleNameChange}
              value={studentName || ""} />
            
            <FontAwesomeIcon
              className="school-it-create-required"
              icon={faAsterisk}
              color={"red"} />
            
          </div>
        </div>

        {showStudentContainer &&
        <div className="school-it-create-dropdown">
            {role === "group" ?
          groupSections.length > 0 ?
          groupSections.map((section) => {
            const availableItems = (section.items || []).filter(
              (item) =>
              !(selectedStudent || []).some((g) => g?.id === item?.id)
            );
            if (availableItems.length === 0) return null;
            return (
              <div
                key={section.title}
                className="school-it-create-group-section">
                
                      <div className="school-it-create-group-section-title">
                        {section.title}
                      </div>
                      <ul className="maintain-group-student-dropdown-menu school-it-create-group-section-list">
                        {availableItems.map((item) =>
                  <li
                    key={item?.id}
                    onClick={() => selectedStudentHandler(item)}
                    className="flex maintain-group-student-list cursor">
                    
                            <span>{item?.name}</span>
                          </li>
                  )}
                      </ul>
                    </div>);

          }) :

          <div className="school-it-create-dropdown-empty">
                  No groups found
                </div> :

          studentList?.length > 0 ?
          <ul className="maintain-group-student-dropdown-menu">
                {studentList.map((item, index) =>
            <li
              key={item?.id || index}
              onClick={() => selectedStudentHandler(item)}
              className="flex maintain-group-student-list cursor">
              
                    {item?.current_grade != null &&
              <span
                style={{ marginRight: "15px" }}
                className="dropdown-grade-background">
                {`${item.current_grade}th grade`}</span>}
              
                    <span>{item.name}</span>
                  </li>
            )}
              </ul> :

          <div className="school-it-create-dropdown-empty">
                No students found
              </div>}
          
          </div>}
        

        <div className="school-it-create-chips">
          {(selectedStudentName || []).map((item, index) =>
          <div key={`${item}-${index}`} className="school-it-create-chip">
              {item}
              <span onClick={() => removeSelectedName(index)}>
                <FontAwesomeIcon icon={faTimes} />
              </span>
            </div>
          )}
        </div>

        {role === "group" &&
        <div className="school-it-create-field">
            <label className="school-it-create-label">Subject</label>
            <div className="school-it-create-input-wrap">
              <input
              placeholder="Type the subject"
              value={subjectValue}
              onChange={(e) => setSubjectValue(e.target.value)} />
            
              <FontAwesomeIcon
              className="school-it-create-required"
              icon={faAsterisk}
              color={"red"} />
            
            </div>
          </div>}
        

        <div className="school-it-create-field">
          <label className="school-it-create-label">Message</label>
          <div className="school-it-create-input-wrap">
            <textarea
              rows="5"
              placeholder="Type the message content"
              value={message}
              onChange={(e) => setMessage(e.target.value)} />
            
            <FontAwesomeIcon
              className="school-it-create-required"
              icon={faAsterisk}
              color={"red"} />
            
          </div>
        </div>

        <div className="school-it-create-file">
          {!fileDataFromApi &&
          <input type="file" ref={inputFileRef} onChange={handleFileChange} />}
          
          {fileDataFromApi &&
          <span>
              <span
              style={{
                color: "#1395f2",
                fontSize: "14px",
                wordBreak: "break-all"
              }}>
              
                {fileDataFromApi?.filename}
              </span>
              <FontAwesomeIcon
              icon={faTimes}
              color="#1395f2"
              style={{ cursor: "pointer", marginLeft: "5px" }}
              onClick={() => setFileDataFromApi()} />
            
            </span>}
          
        </div>

        <div className="school-it-create-ack">
          <input
            type="checkbox"
            onChange={() => setAckParentValue(!ackParentValue)}
            checked={ackParentValue}
            id="school-it-parent-ack" />
          
          <label htmlFor="school-it-parent-ack">
            <strong>Parent ACK</strong>
          </label>
        </div>

        <div className="school-it-create-actions">
          <button
            type="button"
            onClick={role === "group" ? sendGroupMessage : sendMessage}
            disabled={sending || !canSend}
            className={`school-it-create-send ${canSend ? "is-ready" : ""}`}>
            
            {sending ?
            <MessageSendSpinner size={16} /> :

            <FontAwesomeIcon icon={faEnvelope} />}
            
            Send Message
          </button>
        </div>
      </div>
    </Fragment>);

};

export default CreateMessage;